<template>
    <div class="form-check-inline col-12">
        <small class="form-check-label" for="per_page">Elementos por página: </small>
        <select id="per_page" class="custom-select custom-select-sm" v-bind:value="value" v-on:input="$emit('input', $event.target.value)" v-on:change="$emit('change')">
            <option value="5" :selected="value == 5">5</option>
            <option value="10" :selected="value == 10">10</option>
            <option value="15" :selected="value == 15">15</option>
            <option value="20" :selected="value == 20">20</option>
        </select>
    </div>
</template>

<script>
export default {
    props: ['value']
}
</script>